<section class="mx-auto w-full max-w-7xl px-4 py-8 sm:px-6 lg:px-8">
  <div class="mb-5 flex flex-wrap items-center justify-between gap-3">
    <div>
      <h1 class="text-2xl font-semibold text-slate-900">
        Licencias y Renovaciones
      </h1>
      <p class="text-sm text-slate-500">
        Monitorea vencimientos y renueva con un clic.
      </p>
    </div>
    <div class="flex items-center gap-2">
      <input
        type="text"
        class="w-64 rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-sky-500 focus:ring-2 focus:ring-sky-200"
        placeholder="Buscar por nombre o RUC"
        [(ngModel)]="searchTerm"
        (input)="applyFilter()"
      />
      <button
        class="rounded-lg border border-slate-300 bg-white px-3 py-2 text-slate-700 transition hover:bg-slate-50 disabled:opacity-70"
        (click)="loadLicencias()"
        [disabled]="loading"
      >
        <i class="bi bi-arrow-clockwise"></i>
      </button>
    </div>
  </div>

  <div
    class="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
  >
    @if (loading) {
      <div class="flex items-center justify-center gap-2 px-4 py-12">
        <div
          class="h-5 w-5 animate-spin rounded-full border-2 border-slate-300 border-t-sky-600"
        ></div>
        <span class="text-sm text-slate-500">Cargando licencias...</span>
      </div>
    }

    @if (error && !loading) {
      <div
        class="m-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700"
      >
        <i class="bi bi-exclamation-triangle mr-2"></i>{{ error }}
      </div>
    }

    @if (!loading && !error) {
      <div class="overflow-x-auto">
        <table class="min-w-full divide-y divide-slate-200 text-sm">
          <thead class="bg-slate-50">
            <tr>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Empresa
              </th>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                RUC
              </th>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Inicio
              </th>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Vencimiento
              </th>
              <th class="px-4 py-3 text-left font-semibold text-slate-600">
                Estado
              </th>
              <th class="px-4 py-3 text-right font-semibold text-slate-600">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody class="divide-y divide-slate-200 bg-white">
            @for (empresa of filteredEmpresas; track empresa.id) {
              <tr class="hover:bg-slate-50">
                <td class="px-4 py-3 font-semibold text-slate-900">
                  {{ empresa.nombre }}
                </td>
                <td class="px-4 py-3 text-slate-700">{{ empresa.ruc }}</td>
                <td class="px-4 py-3 text-slate-700">
                  {{
                    $safeNavigationMigration(empresa.licencia?.fecha_inicio) | date: "dd/MM/yyyy" : "UTC"
                  }}
                </td>
                <td class="px-4 py-3 text-slate-700">
                  {{ $safeNavigationMigration(empresa.licencia?.fecha_fin) | date: "dd/MM/yyyy" : "UTC" }}
                </td>
                <td class="px-4 py-3">
                  @let status = getEstado(empresa);
                  <span
                    class="inline-flex rounded-full px-2.5 py-1 text-xs font-medium"
                    [ngClass]="status.className"
                    >{{ status.label }}</span
                  >
                </td>
                <td class="px-4 py-3 text-right">
                  <button
                    class="rounded-lg bg-slate-900 px-3 py-1.5 text-xs font-medium text-white transition hover:bg-slate-700"
                    (click)="openRenewModal(empresa)"
                  >
                    <i class="bi bi-arrow-repeat mr-1"></i> Renovar
                  </button>
                </td>
              </tr>
            }
            @if (filteredEmpresas.length === 0) {
              <tr>
                <td
                  colspan="6"
                  class="px-4 py-12 text-center text-sm text-slate-500"
                >
                  No hay licencias registradas para mostrar.
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</section>

@if (showRenewModal) {
  <div
    class="fixed inset-0 z-[1050] flex items-center justify-center bg-black/45 p-4"
  >
    <div class="w-full max-w-md rounded-2xl bg-white p-5 shadow-2xl">
      <div class="mb-4 flex items-center justify-between">
        <h5 class="text-lg font-semibold text-slate-900">Renovar licencia</h5>
        <button
          type="button"
          class="rounded-lg border border-slate-300 px-2 py-1 text-slate-600"
          (click)="closeRenewModal()"
        >
          <i class="bi bi-x"></i>
        </button>
      </div>
      <div class="space-y-3">
        <p class="text-sm text-slate-700">
          Empresa: <strong>{{ selectedEmpresa?.nombre }}</strong>
        </p>
        <label
          for="renewalDate"
          class="block text-sm font-medium text-slate-700"
          >Nueva fecha de vencimiento</label
        >
        <input
          id="renewalDate"
          type="date"
          class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-sky-500 focus:ring-2 focus:ring-sky-200"
          [(ngModel)]="renewalDate"
        />
        <small class="block text-xs text-slate-500">Formato: YYYY-MM-DD</small>
      </div>
      <div class="mt-5 flex justify-end gap-2">
        <button
          class="rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm font-medium text-slate-700"
          (click)="closeRenewModal()"
        >
          Cancelar
        </button>
        <button
          class="rounded-lg bg-slate-900 px-3 py-2 text-sm font-medium text-white"
          (click)="confirmRenewal()"
        >
          Guardar renovación
        </button>
      </div>
    </div>
  </div>
}

<app-toast aria-live="polite" aria-atomic="true"></app-toast>
